import Vue from 'vue';
import Router from 'vue-router';
import Utils from './Utils';
import { isAdmin, isAuthenticated } from './utils/authUtils';
import Home from './views/Main/Home.vue';
import MainLayout from './views/Main/MainLayout.vue';
import Reset from './views/Main/ResetPassword.vue';
import Submission from './views/Main/Submission.vue';

const AdminLogin = () => import('@/views/Admin/AdminLogin.vue');
const AdminHome = () => import('@/views/Admin/AdminHome.vue');
const AdminLayout = () => import('@/views/Admin/AdminLayout.vue');

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // TODO: Use vue transition hooks instead of hard-coding this time
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 500);
    });
  },
  routes: [
    {
      children: [
        {
          path: '/admin/login',
          name: 'adminLogin',
          component: AdminLogin,
        },
        {
          path: '',
          name: 'admin',
          component: AdminHome,
          beforeEnter: (to, from, next) => {
            if (isAdmin()) {
              next();
            } else if (isAuthenticated()) {
              Utils.toastShow("You don't have permission to view this page.");
              next(from.fullPath);
            } else {
              next('/admin/login');
            }
          },
        },
      ],
      component: AdminLayout,
      path: '/admin',
    },
    {
      children: [
        {
          path: '/submission',
          name: 'submission',
          component: Submission,
          props: route => ({
            resetToken: route.query.t,
            email: route.query.e ? atob(decodeURIComponent((route.query as any).e)) : '',
          }),
          beforeEnter(to, from, next) {
            if (!isAuthenticated() && (!to.query.t || !to.query.e)) {
              next(from.fullPath);
            }
            next();
          },
        },
        {
          path: '/reset',
          name: 'reset password',
          component: Reset,
          props: route => ({
            resetToken: route.query.t,
            resetEmail: route.query.e
              ? atob(decodeURIComponent((route.query as any).e))
              : '',
          }),
        },
        { path: '', name: 'home', component: Home },
      ],
      component: MainLayout,
      path: '*',
    },
  ],
});
